import { render, staticRenderFns } from "./AttachmentsBox.vue?vue&type=template&id=2281c514&scoped=true"
import script from "./AttachmentsBox.vue?vue&type=script&lang=js"
export * from "./AttachmentsBox.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsBox.vue?vue&type=style&index=0&id=2281c514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2281c514",
  null
  
)

export default component.exports